import {ThunkDispatch} from "@reduxjs/toolkit";
import {useSelector, useDispatch} from 'react-redux'
import { Link } from "react-router-dom";
import LoginHeader from "./LoginHeader";
import LogoHeader from "./LogoHeader";

const LoginResetPassEmailSent = ({view} : {view: 'company' | 'talent'}) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const loginUrl = view == 'company' ? '/company/login' : '/talent/login'

  return (
    <div className='static md:fixed md:inset-0 bg-alu-base'>
      <div className='min-w-[24.75rem] static md:absolute md:top-1/2 left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2'>
        <LogoHeader view={view} page="advanced"></LogoHeader>
        <div className='bg-white md:rounded-2xl md:shadow-lg md:max-w-[21.4378rem] md:m-auto md:min-h-max min-h-screen w-full py-0 md:py-6'>
          <LoginHeader title="パスワード再設定"></LoginHeader>
          <div className="flex flex-col items-center justify-center mt-[3.125rem] md:mt-4 px-4 md:px-6">
            <p className='alu-text-base-2 text-sm mb-4'>ご指定のメールアドレスに、パスワード再設定用のメールを送信しました。</p>
            <p className='alu-text-base-2 text-sm mb-4'>メールをご確認いただき、記載された手順にしたがって設定を完了してください。</p>
            <p className='inline-flex justify-center items-center'>
              <Link to={loginUrl} className='text-link px-2 py-1 hover:bg-[#fff3e5] rounded text-sm'>ログイン画面に戻る</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginResetPassEmailSent;